<!-- 品牌新增,修改 -->
<template>
	<el-dialog :modal-append-to-body="false" :title="titleValue" :visible.sync="visible" width="60%" :close-on-click-modal="false" @close="close">
        <el-form :model="form" autocomplete="off" label-width="120px">
            <div style="font-weight:bold;width:100%;height:30px;padding-left:10px;">基础配置</div>
            <el-form-item required label="品牌标识">
                <el-input v-model="form.brandIdentify" placeholder="请输入英文品牌标识" maxlength="32" show-word-limit
                autocomplete="off" :disabled="this.operType == 'update'" style="width:90%"></el-input>
            </el-form-item>
            <el-form-item required label="品牌名称">
                <el-input v-model="form.brandName" placeholder="请输入品牌名称" maxlength="10" autocomplete="off" style="width:90%"></el-input>
            </el-form-item>
            <el-form-item required label="品牌状态">
                <el-radio-group v-model="form.brandState">
                    <el-radio name='type' :label="0">正常</el-radio>
                    <el-radio name='type' :label="1">锁定</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="备注">
                <el-input v-model="form.remarks" placeholder="请输入备注" maxlength="30" type="textarea" autocomplete="off" style="width:90%;"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{needCreateSubBrand?`退出登录`:`取 消`}}</el-button>
            <el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: "brandManage",
	data() {
		return {
            loading: false,
			visible: false,
            operType: "",
			titleValue: "",
            form: {
                brandIdentify: "",
                brandName: "",
                isDeleted: "0",
                brandState: "0",
                // brandLogo: '',
                // faviconLogo: '',
                menuList: [],
                parentBrandIdentify: "",
                // publicNetworkLogin: "",
                remarks: ""
            },
		}
	},
    computed: {
        ...mapGetters([
            'needCreateSubBrand'
        ])
    },
    methods: {
        open(operType, brandData){
            switch(operType){
                case "addBrand":
                    this.titleValue = '新增品牌';
                    this.operType = "save";
                    this.checkType = "createBrand";
                    this.form = {
                        brandIdentify: "",
                        brandName: "",
                        isDeleted: "0",
                        brandState: 0,
                        menuList: [],
                        parentBrandIdentify: "",
                        remarks: ""
                    }
                    break;
                case "addSubBrand":
                    this.titleValue = '新增子品牌';
                    this.operType = "save";
                    this.checkType = "createSubBrand";
                    this.form = {
                        brandState: 0,
                        parentBrandIdentify: brandData.brandIdentify
                    }
                    break;
                case "updateBrand":
                    this.titleValue = '修改品牌';
                    this.operType = "update";
                    this.checkType = "update";
                    this.form = Object.assign({},brandData);
                    this.form.brandState = parseInt(this.form.brandState);
                    break;
                default: 
                    return;
            }
            this.visible = true;
        },
        close(){
            if(this.needCreateSubBrand){
                this.$store.dispatch('user/logout');
            }
        },
        // 提交修改
        commit () {
            if (!this.form.brandIdentify || !this.form.brandName) {
                this.$message.error('必填项不能为空')
                return false
            }
            if (this.checkType == "createBrand") {
                let regex = /^[a-z]{1}[a-z0-9]{0,31}$/;
                if (!regex.test(this.form.brandIdentify)) {
                    this.$message.error('品牌标识只允许小写英文和数字,并以字母开头')
                    return false
                }
            } else if (this.checkType == "createSubBrand") {
                let regex = /^[a-z]{1}[a-z0-9-]{0,31}$/;
                if (!regex.test(this.form.brandIdentify)) {
                    this.$message.error('子品牌标识只允许小写英文、数字和中划线,并以字母开头')
                    return false
                }
            }

            this.loading = true;
            this.$api.getBrandSaves(this.operType, {
                ...this.form
            }).then(res => {
                if(res && res.errcode != 0) return false;
                if (this.checkType == "createBrand" || this.checkType == "createSubBrand") {
                    this.$message.success('新增成功!')
                    if(this.needCreateSubBrand) {
                        this.$store.commit("user/SET_NEED_CREATE_SUB_BRAND", false);
                    }
                } else {
                    this.$message.success('修改成功!')
                }
                this.$emit("handleDone");
                this.visible = false;
            }).finally(()=>{
                this.loading = false;
            })
        },
    }
}	
</script>

<style lang="sass" scoped>
	
</style>